import { Injectable } from '@angular/core';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { getUserId } from '../../selectors/init.selectors';
import { userManagementFeatureStoreKey } from '../feature/user-management.feature';
import {
  ContactNotification,
  ContactStatusNotification,
  Notifications,
  UserManagementState,
} from '../state/user-management.state';

export const getUserManagementState =
  createFeatureSelector<UserManagementState>(userManagementFeatureStoreKey);

export const getUserDropdownList = createSelector(
  getUserManagementState,
  (state) => state.userDropdownList,
);

export const getNotifications = createSelector(
  getUserManagementState,
  getUserId,
  (state, userId) => {
    const contacts: Notifications[] = generateNotifications(
      [...(state.notifications?.contacts ?? [])].sort(
        (left, right) =>
          new Date(right.updated_at ?? right.created_at).getTime() -
          new Date(left.updated_at ?? left.created_at).getTime(),
      ),
      userId,
      'contacts',
    );
    return [...contacts];
  },
);

export const generateNotifications = (
  contacts: ContactNotification[],
  userId,
  type: string,
): Notifications[] => {
  const contactArr: Notifications[] = [];
  if (contacts?.length) {
    contacts.forEach((val: ContactNotification, ind: number) => {
      const obj: Notifications = {
        uId: val.uId,
        contactUserId: val.contactUserId,
        requestedByUserId: val.requestedByUserId,
        isRequester:
          val.requestedByUserId !== undefined
            ? userId === val.requestedByUserId
            : userId === val.uId,
        firstName: val.firstName,
        lastName: val.lastName,
        date: val.updated_at ?? val.created_at,
        status:
          val.requestedByUserId !== undefined
            ? userId === val.requestedByUserId
              ? val.status
              : val.status === ContactStatusNotification.REQUEST_SENT
                ? ContactStatusNotification.REQUEST_RECEIVED
                : val.status
            : userId == val.contactUserId &&
                val.status === ContactStatusNotification.REQUEST_SENT
              ? ContactStatusNotification.REQUEST_RECEIVED
              : val.status,
        email: val.emailId,
        isRead: false,
        trackingId: ind,
      };
      contactArr.push(obj);
    });
  }
  return contactArr;
};

export const getMessages = createSelector(
  getUserManagementState,
  (state) => state.messages,
);

export const getContacts = createSelector(
  getUserManagementState,
  (state) => state.contacts,
);

export const getIsSignOutError = createSelector(
  getUserManagementState,
  (state) => state.isSignOutError,
);

export const getInitialUserManagementApiLoadingStatus = createSelector(
  getUserManagementState,
  (state) =>
    state.isNotificationsLoading ||
    state.isContactLoading ||
    state.isMessagesLoading,
);

@Injectable({
  providedIn: 'root',
})
export class UserManagementSelectors {
  getUserDropdownList$ = this.store.select(getUserDropdownList);
  getNotifications$ = this.store.select(getNotifications);
  getMessages$ = this.store.select(getMessages);
  getContacts$ = this.store.select(getContacts);
  getIsSignOutError$ = this.store.select(getIsSignOutError);
  getInitialUserManagementApiLoadingStatus$ = this.store.select(
    getInitialUserManagementApiLoadingStatus,
  );

  constructor(private store: Store<UserManagementState>) {}
}
